import { defineComponent as lt, h as v, Fragment as ot, ref as c, computed as u, watchEffect as nt, onMounted as rt, onBeforeUnmount as it, mergeProps as at, Transition as ue } from "vue";
import st from "./highrise1769.mjs";
import fe from "./highrise1125.mjs";
import ct from "./highrise1053.mjs";
import { useRtl as ut } from "./highrise1067.mjs";
import me from "./highrise984.mjs";
import ft from "./highrise986.mjs";
import { depx as de, getMargin as D } from "./highrise1080.mjs";
import { useReactivated as dt } from "./highrise1537.mjs";
import { off as C, on as I } from "./highrise632.mjs";
import { rtlInset as he } from "./highrise1539.mjs";
import { useThemeClass as ht } from "./highrise1062.mjs";
import vt from "./highrise637.mjs";
import { Wrapper as ve } from "./highrise1541.mjs";
import { getPreciseEventTarget as mt } from "./highrise1159.mjs";
const bt = Object.assign(Object.assign({}, me.props), {
  duration: {
    type: Number,
    default: 0
  },
  scrollable: {
    type: Boolean,
    default: !0
  },
  xScrollable: Boolean,
  trigger: {
    type: String,
    default: "hover"
  },
  useUnifiedContainer: Boolean,
  triggerDisplayManually: Boolean,
  // If container is set, resize observer won't not attached
  container: Function,
  content: Function,
  containerClass: String,
  containerStyle: [String, Object],
  contentClass: [String, Array],
  contentStyle: [String, Object],
  horizontalRailStyle: [String, Object],
  verticalRailStyle: [String, Object],
  onScroll: Function,
  onWheel: Function,
  onResize: Function,
  internalOnUpdateScrollLeft: Function,
  internalHoistYRail: Boolean,
  yPlacement: {
    type: String,
    default: "right"
  },
  xPlacement: {
    type: String,
    default: "bottom"
  }
}), gt = lt({
  name: "Scrollbar",
  props: bt,
  inheritAttrs: !1,
  setup(i) {
    const {
      mergedClsPrefixRef: R,
      inlineThemeDisabled: s,
      mergedRtlRef: $
    } = ct(i), o = ut("Scrollbar", $, R), W = c(null), Y = c(null), E = c(null), M = c(null), S = c(null), w = c(null), B = c(null), y = c(null), d = c(null), p = c(null), V = c(null), H = c(0), X = c(0), O = c(!1), U = c(!1);
    let _ = !1, j = !1, m, b, K = 0, Q = 0, F = 0, Z = 0;
    const be = vt(), A = me("Scrollbar", "-scrollbar", st, ft, i, R), N = u(() => {
      const {
        value: e
      } = y, {
        value: t
      } = w, {
        value: l
      } = p;
      return e === null || t === null || l === null ? 0 : Math.min(e, l * e / t + de(A.value.self.width) * 1.5);
    }), ge = u(() => `${N.value}px`), G = u(() => {
      const {
        value: e
      } = d, {
        value: t
      } = B, {
        value: l
      } = V;
      return e === null || t === null || l === null ? 0 : l * e / t + de(A.value.self.height) * 1.5;
    }), Re = u(() => `${G.value}px`), pe = u(() => {
      const {
        value: e
      } = y, {
        value: t
      } = H, {
        value: l
      } = w, {
        value: n
      } = p;
      if (e === null || l === null || n === null)
        return 0;
      {
        const a = l - e;
        return a ? t / a * (n - N.value) : 0;
      }
    }), Se = u(() => `${pe.value}px`), we = u(() => {
      const {
        value: e
      } = d, {
        value: t
      } = X, {
        value: l
      } = B, {
        value: n
      } = V;
      if (e === null || l === null || n === null)
        return 0;
      {
        const a = l - e;
        return a ? t / a * (n - G.value) : 0;
      }
    }), Be = u(() => `${we.value}px`), ee = u(() => {
      const {
        value: e
      } = y, {
        value: t
      } = w;
      return e !== null && t !== null && t > e;
    }), te = u(() => {
      const {
        value: e
      } = d, {
        value: t
      } = B;
      return e !== null && t !== null && t > e;
    }), ye = u(() => {
      const {
        trigger: e
      } = i;
      return e === "none" || O.value;
    }), xe = u(() => {
      const {
        trigger: e
      } = i;
      return e === "none" || U.value;
    }), z = u(() => {
      const {
        container: e
      } = i;
      return e ? e() : Y.value;
    }), ze = u(() => {
      const {
        content: e
      } = i;
      return e ? e() : E.value;
    }), le = (e, t) => {
      if (!i.scrollable) return;
      if (typeof e == "number") {
        L(e, t ?? 0, 0, !1, "auto");
        return;
      }
      const {
        left: l,
        top: n,
        index: a,
        elSize: f,
        position: g,
        behavior: r,
        el: h,
        debounce: x = !0
      } = e;
      (l !== void 0 || n !== void 0) && L(l ?? 0, n ?? 0, 0, !1, r), h !== void 0 ? L(0, h.offsetTop, h.offsetHeight, x, r) : a !== void 0 && f !== void 0 ? L(0, a * f, f, x, r) : g === "bottom" ? L(0, Number.MAX_SAFE_INTEGER, 0, !1, r) : g === "top" && L(0, 0, 0, !1, r);
    }, oe = dt(() => {
      i.container || le({
        top: H.value,
        left: X.value
      });
    }), Te = () => {
      oe.isDeactivated || T();
    }, Me = (e) => {
      if (oe.isDeactivated) return;
      const {
        onResize: t
      } = i;
      t && t(e), T();
    }, He = (e, t) => {
      if (!i.scrollable) return;
      const {
        value: l
      } = z;
      l && (typeof e == "object" ? l.scrollBy(e) : l.scrollBy(e, t || 0));
    };
    function L(e, t, l, n, a) {
      const {
        value: f
      } = z;
      if (f) {
        if (n) {
          const {
            scrollTop: g,
            offsetHeight: r
          } = f;
          if (t > g) {
            t + l <= g + r || f.scrollTo({
              left: e,
              top: t + l - r,
              behavior: a
            });
            return;
          }
        }
        f.scrollTo({
          left: e,
          top: t,
          behavior: a
        });
      }
    }
    function Le() {
      Xe(), $e(), T();
    }
    function Pe() {
      k();
    }
    function k() {
      Ce(), We();
    }
    function Ce() {
      b !== void 0 && window.clearTimeout(b), b = window.setTimeout(() => {
        U.value = !1;
      }, i.duration);
    }
    function We() {
      m !== void 0 && window.clearTimeout(m), m = window.setTimeout(() => {
        O.value = !1;
      }, i.duration);
    }
    function Xe() {
      m !== void 0 && window.clearTimeout(m), O.value = !0;
    }
    function $e() {
      b !== void 0 && window.clearTimeout(b), U.value = !0;
    }
    function Ye(e) {
      const {
        onScroll: t
      } = i;
      t && t(e), ne();
    }
    function ne() {
      const {
        value: e
      } = z;
      e && (H.value = e.scrollTop, X.value = e.scrollLeft * (o != null && o.value ? -1 : 1));
    }
    function Ee() {
      const {
        value: e
      } = ze;
      e && (w.value = e.offsetHeight, B.value = e.offsetWidth);
      const {
        value: t
      } = z;
      t && (y.value = t.offsetHeight, d.value = t.offsetWidth);
      const {
        value: l
      } = S, {
        value: n
      } = M;
      l && (V.value = l.offsetWidth), n && (p.value = n.offsetHeight);
    }
    function re() {
      const {
        value: e
      } = z;
      e && (H.value = e.scrollTop, X.value = e.scrollLeft * (o != null && o.value ? -1 : 1), y.value = e.offsetHeight, d.value = e.offsetWidth, w.value = e.scrollHeight, B.value = e.scrollWidth);
      const {
        value: t
      } = S, {
        value: l
      } = M;
      t && (V.value = t.offsetWidth), l && (p.value = l.offsetHeight);
    }
    function T() {
      i.scrollable && (i.useUnifiedContainer ? re() : (Ee(), ne()));
    }
    function ie(e) {
      var t;
      return !(!((t = W.value) === null || t === void 0) && t.contains(mt(e)));
    }
    function Ve(e) {
      e.preventDefault(), e.stopPropagation(), j = !0, I("mousemove", window, ae, !0), I("mouseup", window, se, !0), Q = X.value, F = o != null && o.value ? window.innerWidth - e.clientX : e.clientX;
    }
    function ae(e) {
      if (!j) return;
      m !== void 0 && window.clearTimeout(m), b !== void 0 && window.clearTimeout(b);
      const {
        value: t
      } = d, {
        value: l
      } = B, {
        value: n
      } = G;
      if (t === null || l === null) return;
      const f = (o != null && o.value ? window.innerWidth - e.clientX - F : e.clientX - F) * (l - t) / (t - n), g = l - t;
      let r = Q + f;
      r = Math.min(g, r), r = Math.max(r, 0);
      const {
        value: h
      } = z;
      if (h) {
        h.scrollLeft = r * (o != null && o.value ? -1 : 1);
        const {
          internalOnUpdateScrollLeft: x
        } = i;
        x && x(r);
      }
    }
    function se(e) {
      e.preventDefault(), e.stopPropagation(), C("mousemove", window, ae, !0), C("mouseup", window, se, !0), j = !1, T(), ie(e) && k();
    }
    function De(e) {
      e.preventDefault(), e.stopPropagation(), _ = !0, I("mousemove", window, q, !0), I("mouseup", window, J, !0), K = H.value, Z = e.clientY;
    }
    function q(e) {
      if (!_) return;
      m !== void 0 && window.clearTimeout(m), b !== void 0 && window.clearTimeout(b);
      const {
        value: t
      } = y, {
        value: l
      } = w, {
        value: n
      } = N;
      if (t === null || l === null) return;
      const f = (e.clientY - Z) * (l - t) / (t - n), g = l - t;
      let r = K + f;
      r = Math.min(g, r), r = Math.max(r, 0);
      const {
        value: h
      } = z;
      h && (h.scrollTop = r);
    }
    function J(e) {
      e.preventDefault(), e.stopPropagation(), C("mousemove", window, q, !0), C("mouseup", window, J, !0), _ = !1, T(), ie(e) && k();
    }
    nt(() => {
      const {
        value: e
      } = te, {
        value: t
      } = ee, {
        value: l
      } = R, {
        value: n
      } = S, {
        value: a
      } = M;
      n && (e ? n.classList.remove(`${l}-scrollbar-rail--disabled`) : n.classList.add(`${l}-scrollbar-rail--disabled`)), a && (t ? a.classList.remove(`${l}-scrollbar-rail--disabled`) : a.classList.add(`${l}-scrollbar-rail--disabled`));
    }), rt(() => {
      i.container || T();
    }), it(() => {
      m !== void 0 && window.clearTimeout(m), b !== void 0 && window.clearTimeout(b), C("mousemove", window, q, !0), C("mouseup", window, J, !0);
    });
    const ce = u(() => {
      const {
        common: {
          cubicBezierEaseInOut: e
        },
        self: {
          color: t,
          colorHover: l,
          height: n,
          width: a,
          borderRadius: f,
          railInsetHorizontalTop: g,
          railInsetHorizontalBottom: r,
          railInsetVerticalRight: h,
          railInsetVerticalLeft: x,
          railColor: Ie
        }
      } = A.value, {
        top: Oe,
        right: Ue,
        bottom: _e,
        left: je
      } = D(g), {
        top: Fe,
        right: Ae,
        bottom: Ne,
        left: Ge
      } = D(r), {
        top: ke,
        right: qe,
        bottom: Je,
        left: Ke
      } = D(o != null && o.value ? he(h) : h), {
        top: Qe,
        right: Ze,
        bottom: et,
        left: tt
      } = D(o != null && o.value ? he(x) : x);
      return {
        "--n-scrollbar-bezier": e,
        "--n-scrollbar-color": t,
        "--n-scrollbar-color-hover": l,
        "--n-scrollbar-border-radius": f,
        "--n-scrollbar-width": a,
        "--n-scrollbar-height": n,
        "--n-scrollbar-rail-top-horizontal-top": Oe,
        "--n-scrollbar-rail-right-horizontal-top": Ue,
        "--n-scrollbar-rail-bottom-horizontal-top": _e,
        "--n-scrollbar-rail-left-horizontal-top": je,
        "--n-scrollbar-rail-top-horizontal-bottom": Fe,
        "--n-scrollbar-rail-right-horizontal-bottom": Ae,
        "--n-scrollbar-rail-bottom-horizontal-bottom": Ne,
        "--n-scrollbar-rail-left-horizontal-bottom": Ge,
        "--n-scrollbar-rail-top-vertical-right": ke,
        "--n-scrollbar-rail-right-vertical-right": qe,
        "--n-scrollbar-rail-bottom-vertical-right": Je,
        "--n-scrollbar-rail-left-vertical-right": Ke,
        "--n-scrollbar-rail-top-vertical-left": Qe,
        "--n-scrollbar-rail-right-vertical-left": Ze,
        "--n-scrollbar-rail-bottom-vertical-left": et,
        "--n-scrollbar-rail-left-vertical-left": tt,
        "--n-scrollbar-rail-color": Ie
      };
    }), P = s ? ht("scrollbar", void 0, ce, i) : void 0;
    return Object.assign(Object.assign({}, {
      scrollTo: le,
      scrollBy: He,
      sync: T,
      syncUnifiedContainer: re,
      handleMouseEnterWrapper: Le,
      handleMouseLeaveWrapper: Pe
    }), {
      mergedClsPrefix: R,
      rtlEnabled: o,
      containerScrollTop: H,
      wrapperRef: W,
      containerRef: Y,
      contentRef: E,
      yRailRef: M,
      xRailRef: S,
      needYBar: ee,
      needXBar: te,
      yBarSizePx: ge,
      xBarSizePx: Re,
      yBarTopPx: Se,
      xBarLeftPx: Be,
      isShowXBar: ye,
      isShowYBar: xe,
      isIos: be,
      handleScroll: Ye,
      handleContentResize: Te,
      handleContainerResize: Me,
      handleYScrollMouseDown: De,
      handleXScrollMouseDown: Ve,
      cssVars: s ? void 0 : ce,
      themeClass: P == null ? void 0 : P.themeClass,
      onRender: P == null ? void 0 : P.onRender
    });
  },
  render() {
    var i;
    const {
      $slots: R,
      mergedClsPrefix: s,
      triggerDisplayManually: $,
      rtlEnabled: o,
      internalHoistYRail: W,
      yPlacement: Y,
      xPlacement: E,
      xScrollable: M
    } = this;
    if (!this.scrollable) return (i = R.default) === null || i === void 0 ? void 0 : i.call(R);
    const S = this.trigger === "none", w = (d, p) => v("div", {
      ref: "yRailRef",
      class: [`${s}-scrollbar-rail`, `${s}-scrollbar-rail--vertical`, `${s}-scrollbar-rail--vertical--${Y}`, d],
      "data-scrollbar-rail": !0,
      style: [p || "", this.verticalRailStyle],
      "aria-hidden": !0
    }, v(S ? ve : ue, S ? null : {
      name: "fade-in-transition"
    }, {
      default: () => this.needYBar && this.isShowYBar && !this.isIos ? v("div", {
        class: `${s}-scrollbar-rail__scrollbar`,
        style: {
          height: this.yBarSizePx,
          top: this.yBarTopPx
        },
        onMousedown: this.handleYScrollMouseDown
      }) : null
    })), B = () => {
      var d, p;
      return (d = this.onRender) === null || d === void 0 || d.call(this), v("div", at(this.$attrs, {
        role: "none",
        ref: "wrapperRef",
        class: [`${s}-scrollbar`, this.themeClass, o && `${s}-scrollbar--rtl`],
        style: this.cssVars,
        onMouseenter: $ ? void 0 : this.handleMouseEnterWrapper,
        onMouseleave: $ ? void 0 : this.handleMouseLeaveWrapper
      }), [this.container ? (p = R.default) === null || p === void 0 ? void 0 : p.call(R) : v("div", {
        role: "none",
        ref: "containerRef",
        class: [`${s}-scrollbar-container`, this.containerClass],
        style: this.containerStyle,
        onScroll: this.handleScroll,
        onWheel: this.onWheel
      }, v(fe, {
        onResize: this.handleContentResize
      }, {
        default: () => v("div", {
          ref: "contentRef",
          role: "none",
          style: [{
            width: this.xScrollable ? "fit-content" : null
          }, this.contentStyle],
          class: [`${s}-scrollbar-content`, this.contentClass]
        }, R)
      })), W ? null : w(void 0, void 0), M && v("div", {
        ref: "xRailRef",
        class: [`${s}-scrollbar-rail`, `${s}-scrollbar-rail--horizontal`, `${s}-scrollbar-rail--horizontal--${E}`],
        style: this.horizontalRailStyle,
        "data-scrollbar-rail": !0,
        "aria-hidden": !0
      }, v(S ? ve : ue, S ? null : {
        name: "fade-in-transition"
      }, {
        default: () => this.needXBar && this.isShowXBar && !this.isIos ? v("div", {
          class: `${s}-scrollbar-rail__scrollbar`,
          style: {
            width: this.xBarSizePx,
            right: o ? this.xBarLeftPx : void 0,
            left: o ? void 0 : this.xBarLeftPx
          },
          onMousedown: this.handleXScrollMouseDown
        }) : null
      }))]);
    }, y = this.container ? B() : v(fe, {
      onResize: this.handleContainerResize
    }, {
      default: B
    });
    return W ? v(ot, null, y, w(this.themeClass, this.cssVars)) : y;
  }
}), $t = gt;
export {
  $t as XScrollbar,
  gt as default
};
